// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Admin Dashboard Styles */

.admin-dashboard {
    padding: 20px;
  }
  
  .admin-main {
    background-color: #ffffff;
    border-radius: 10px;
    margin-bottom: 20px;
  }
  
  .admin-header {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
  }
  
  .add-user-btn {
    padding: 10px 20px;
    background-color: #007bff;
    color: #ffffff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    transition: background-color 0.3s;
  }
  
  .add-user-btn:hover {
    background-color: #0056b3;
  }
  
  .admin-table-section {
    overflow-x: auto;
  }
  
  .admin-table {
    width: 100%;
    border-collapse: collapse;
    border:1px solid #D0D0D0;
  }
  
  .admin-table th, .admin-table td {
    text-align: left;
    padding: 16px;
    font-weight: 500;
   
  }
  
  .admin-table th {
    background-color: #506CFE;
    color: #ffffff;
    font-weight: bold;
  }
  
  .admin-table th,
  .admin-table td {
    width: 12.5%;
  }
  
  .admin-table tr:nth-child(even) {
    background-color:  #F4F4F4;
  }
  
  .admin-table tr:hover {
    background-color: #e9ecef;
  }
  
  .action-icon {
    font-size: 18px;
    cursor: pointer;
    transition: color 0.3s;
  }
  
  .edit-icon {
    color: #28a745;
    margin-right: 15px;
  }
  
  .edit-icon:hover {
    color: #218838;
  }
  
  .delete-icon {
    color: #dc3545;
  }
  
  .delete-icon:hover {
    color: #c82333;
  }
  
  .pagination {
    margin-top: 15px;
    display: flex;
    justify-content: flex-end;
  }
  
  .pagination-btn {
    margin: 0 5px;
    padding: 2px 5px;
    cursor: pointer;
    background-color: #f0f0f0;
    border: 1px solid #ddd;
    border-radius: 4px;
  }
  
  .pagination-btn.active {
    background-color: #007bff;
    color: white;
    border: 1px solid #007bff;
  }

  `, "",{"version":3,"sources":["webpack://./src/components/Home/index.css"],"names":[],"mappings":"AAAA,2BAA2B;;AAE3B;IACI,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,gBAAgB;;EAElB;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,iBAAiB;EACnB;;EAEA;;IAEE,YAAY;EACd;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,yBAAyB;EAC3B","sourcesContent":["/* Admin Dashboard Styles */\n\n.admin-dashboard {\n    padding: 20px;\n  }\n  \n  .admin-main {\n    background-color: #ffffff;\n    border-radius: 10px;\n    margin-bottom: 20px;\n  }\n  \n  .admin-header {\n    display: flex;\n    justify-content: flex-end;\n    margin-bottom: 10px;\n  }\n  \n  .add-user-btn {\n    padding: 10px 20px;\n    background-color: #007bff;\n    color: #ffffff;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 16px;\n    transition: background-color 0.3s;\n  }\n  \n  .add-user-btn:hover {\n    background-color: #0056b3;\n  }\n  \n  .admin-table-section {\n    overflow-x: auto;\n  }\n  \n  .admin-table {\n    width: 100%;\n    border-collapse: collapse;\n    border:1px solid #D0D0D0;\n  }\n  \n  .admin-table th, .admin-table td {\n    text-align: left;\n    padding: 16px;\n    font-weight: 500;\n   \n  }\n  \n  .admin-table th {\n    background-color: #506CFE;\n    color: #ffffff;\n    font-weight: bold;\n  }\n  \n  .admin-table th,\n  .admin-table td {\n    width: 12.5%;\n  }\n  \n  .admin-table tr:nth-child(even) {\n    background-color:  #F4F4F4;\n  }\n  \n  .admin-table tr:hover {\n    background-color: #e9ecef;\n  }\n  \n  .action-icon {\n    font-size: 18px;\n    cursor: pointer;\n    transition: color 0.3s;\n  }\n  \n  .edit-icon {\n    color: #28a745;\n    margin-right: 15px;\n  }\n  \n  .edit-icon:hover {\n    color: #218838;\n  }\n  \n  .delete-icon {\n    color: #dc3545;\n  }\n  \n  .delete-icon:hover {\n    color: #c82333;\n  }\n  \n  .pagination {\n    margin-top: 15px;\n    display: flex;\n    justify-content: flex-end;\n  }\n  \n  .pagination-btn {\n    margin: 0 5px;\n    padding: 2px 5px;\n    cursor: pointer;\n    background-color: #f0f0f0;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n  }\n  \n  .pagination-btn.active {\n    background-color: #007bff;\n    color: white;\n    border: 1px solid #007bff;\n  }\n\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
